export const TEMPLATE_GROUPS = {
  ASSIGN_TASKS: {
    label: "📋 Assign Tasks",
    templates: [
      "Request @name to notify finance team after placing order",
      "Ask @name to follow-up with trucker to coordinate shipment pickup",
      "Notify @name, @name upon completion of import customs clearance",
      "Ask @name to prepare the customs clearance documents in 5 days",
      "Email name@email.com the confirmation 5 days after delivery",
    ],
  },

  MANAGE_DOCUMENTS: {
    label: "📄 Manage Documents",
    templates: [
      "Email name@email.com the bill of lading 5 days after the ship sails",
      "Send #document to the export customs agent after shipment booking",
      "Forward the purchase order and logistics invoice document to finance team",
      "Request #document from freight forwarder 2 days after goods pickup.",
      "Request @name to send #document after booking shipping to @name",
    ],
  },

  MILESTONE_BASED: {
    label: "🚩 Milestone Based",
    templates: [
      "Email @name the bill of lading 5 days after Shipment Booking",
      "Send #document to the export customs agent after *milestone",
      "Forward the purchase order document to @name on *milestone",
      "Request #document from freight forwarder 2 days after *milestone.",
      "After *milestone notify the import customs agent with #document",
    ],
  },
} as const;
